"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LapExploration_exports = {};
__export(LapExploration_exports, {
  default: () => LapExploration_default
});
module.exports = __toCommonJS(LapExploration_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.6602 1.08984V19.4102H15.2266C15.2266 19.4102 15.168 19.1823 15.0508 18.7266C14.9336 18.2578 14.8294 17.7109 14.7383 17.0859C14.6602 16.4609 14.6276 15.8359 14.6406 15.2109C14.6667 14.5729 14.8164 14.0846 15.0898 13.7461C15.6758 13.0299 16.0729 12.2617 16.2812 11.4414C16.4896 10.6341 16.5677 9.85286 16.5156 9.09766C16.4635 8.34245 16.3073 7.65885 16.0469 7.04688C15.7865 6.42188 15.4805 5.9401 15.1289 5.60156C14.6732 5.09375 14.0807 4.64453 13.3516 4.25391C12.6354 3.85026 11.5352 3.64193 10.0508 3.62891C9.46484 3.62891 8.76823 3.73307 7.96094 3.94141C7.15365 4.14974 6.40495 4.61849 5.71484 5.34766C5.29818 5.77734 4.95964 6.29167 4.69922 6.89062C4.4388 7.47656 4.35417 8.22526 4.44531 9.13672C4.45833 9.33203 4.42578 9.59896 4.34766 9.9375C4.28255 10.276 4.15234 10.6341 3.95703 11.0117C3.95703 11.0117 3.8138 11.2721 3.52734 11.793C3.24089 12.3008 3.11068 12.6198 3.13672 12.75C3.13672 12.75 3.16276 12.8281 3.21484 12.9844C3.26693 13.1276 3.46875 13.2057 3.82031 13.2188C3.82031 13.2188 3.84635 13.2383 3.89844 13.2773C3.95052 13.3164 3.96354 13.4336 3.9375 13.6289V14.1758C3.9375 14.1758 3.95052 14.2083 3.97656 14.2734C4.01562 14.3385 4.11328 14.3971 4.26953 14.4492C4.26953 14.4492 4.27604 14.4622 4.28906 14.4883C4.30208 14.5143 4.28255 14.5599 4.23047 14.625C4.23047 14.625 4.21745 14.6706 4.19141 14.7617C4.16536 14.8529 4.21745 14.9961 4.34766 15.1914C4.47786 15.2565 4.52995 15.4583 4.50391 15.7969C4.47786 16.1224 4.53646 16.3242 4.67969 16.4023C4.67969 16.4023 4.78385 16.4609 4.99219 16.5781C5.20052 16.6953 5.6237 16.7148 6.26172 16.6367C6.49609 16.5977 6.84766 16.5781 7.31641 16.5781C7.78516 16.5781 8.14323 16.7344 8.39062 17.0469L8.60547 19.4102H1.33984V1.08984H19.6602ZM8.15625 8.74609C8.15625 8.09505 8.38411 7.54167 8.83984 7.08594C9.29557 6.63021 9.84896 6.40234 10.5 6.40234C11.151 6.40234 11.7044 6.63021 12.1602 7.08594C12.6159 7.54167 12.8438 8.09505 12.8438 8.74609C12.8438 9.09766 12.7656 9.42969 12.6094 9.74219C12.4661 10.0547 12.2578 10.3216 11.9844 10.543C11.776 10.7122 11.6328 10.9401 11.5547 11.2266C11.4896 11.5 11.4505 11.7474 11.4375 11.9688H9.5625C9.54948 11.7474 9.50391 11.5 9.42578 11.2266C9.36068 10.9401 9.22396 10.7122 9.01562 10.543C8.74219 10.3216 8.52734 10.0547 8.37109 9.74219C8.22786 9.42969 8.15625 9.09766 8.15625 8.74609ZM11.3984 13.5703C11.3984 13.7135 11.3464 13.8372 11.2422 13.9414C11.138 14.0456 11.0078 14.0977 10.8516 14.0977H10.0898C9.94661 14.0977 9.82292 14.0456 9.71875 13.9414C9.61458 13.8372 9.5625 13.7135 9.5625 13.5703V12.7109H11.3984V13.5703ZM10.0898 14.8203H10.8516C11.2031 14.8203 11.5026 14.6966 11.75 14.4492C11.9974 14.2018 12.1211 13.9089 12.1211 13.5703V12.3203H12.1797C12.1667 12.125 12.1797 11.8971 12.2188 11.6367C12.2578 11.3763 12.3359 11.2005 12.4531 11.1094C12.8047 10.8229 13.0781 10.4714 13.2734 10.0547C13.4818 9.63802 13.5859 9.20182 13.5859 8.74609C13.5859 7.89974 13.2799 7.17708 12.668 6.57812C12.069 5.97917 11.3464 5.67969 10.5 5.67969C9.65365 5.67969 8.92448 5.97917 8.3125 6.57812C7.71354 7.17708 7.41406 7.89974 7.41406 8.74609C7.41406 9.20182 7.51172 9.63802 7.70703 10.0547C7.91536 10.4714 8.19531 10.8229 8.54688 11.1094C8.63802 11.1875 8.70312 11.3242 8.74219 11.5195C8.79427 11.7148 8.82031 11.9036 8.82031 12.0859V13.5703C8.82031 13.9089 8.94401 14.2018 9.19141 14.4492C9.4388 14.6966 9.73828 14.8203 10.0898 14.8203Z",
      fill: "currentColor"
    }
  )
);
const SvgLapExploration = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var LapExploration_default = SvgLapExploration;
